export const environment = {
  production: true,
  GA_TRACKING_ID: 'UA-148901032-2',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts